import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar, faCogs, faTools, faPuzzlePiece, faIndustry, faLightbulb } from "@fortawesome/free-solid-svg-icons";
import "./HomeCards.css";
import { useState } from "react";
import { useTranslation } from "react-i18next";

const CardsSection = () => {
  const { t } = useTranslation();

  const qualidades = [
    { icon: faIndustry, title: t("homeCards.excelencia.title"), description: t("homeCards.excelencia.description") },
    { icon: faStar, title: t("homeCards.qualidade.title"), description: t("homeCards.qualidade.description") },
    { icon: faCogs, title: t("homeCards.engenharia.title"), description: t("homeCards.engenharia.description") },
    { icon: faTools, title: t("homeCards.durabilidade.title"), description: t("homeCards.durabilidade.description") },
    { icon: faLightbulb, title: t("homeCards.inovacao.title"), description: t("homeCards.inovacao.description") },
    { icon: faPuzzlePiece, title: t("homeCards.solucoes.title"), description: t("homeCards.solucoes.description") },
  ];

  const [hovered, setHovered] = useState(null);

  return (
    <section className="cards-section pb-5">
      {qualidades.map((card, index) => {
        const isHovered =
          hovered === index || (hovered === 1 && index === 2) || (hovered === 2 && index === 1);

        return (
          <div
            className={`card-home ${isHovered ? "hovered" : ""}`}
            key={index}
            onMouseEnter={() => setHovered(index)}
            onMouseLeave={() => setHovered(null)}
          >
            <FontAwesomeIcon icon={card.icon} size="3x" className="card-icon" />
            <h3>{card.title}</h3>
            <p>{card.description}</p>
          </div>
        );
      })}
    </section>
  );
};

export default CardsSection;
